import backgroundSection2 from "../../assets/backgroundSection2.webp";

export default function Section1() {
	return (
		<section className="relative w-full h-[350px] overflow-hidden">
			<img
				src={backgroundSection2}
				alt="Sección"
				className="w-full h-full object-cover"
			/>
			<div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent flex items-center justify-center">
				<div className=" px-6 text-center">
					<h2 className="text-white text-2xl md:text-4xl font-bold drop-shadow-md">
						Quiénes somos
					</h2>
				</div>
			</div>
		</section>
	);
}
